import { BarChartEntry } from '@views/pages/Dashboard/types';
import { buildGradientColors } from '../../util';
import { theme } from '@store';

interface IUseBarChartProps {
  entries: BarChartEntry[];
  total?: number;
  otherThreshold: number;
}

export const useBarChart = ({
  entries,
  otherThreshold,
  total,
}: IUseBarChartProps) => {
  if (!entries.length) {
    return {
      finalEntries: [] as BarChartEntry[],
      totalValue: 0,
      colors: [] as string[],
      valueKeys: [] as string[],
    };
  }

  const numericKeys = Object.keys(entries[0]).filter(key => key !== 'label');

  const getEntryTotal = (entry: BarChartEntry) =>
    numericKeys.reduce(
      (sum, key) =>
        sum + (typeof entry[key] === 'number' ? (entry[key] as number) : 0),
      0,
    );

  const totalValue =
    total || entries.reduce((prev, curr) => prev + getEntryTotal(curr), 0);

  // const sortedEntries = [...entries].sort((a, b) =>
  //   getEntryTotal(a) < getEntryTotal(b) ? 1 : -1,
  // );

  const highestEntries = [...entries].slice(0, otherThreshold - 1);

  const otherEntry = [...entries]
    .slice(otherThreshold - 1)
    .reduce<BarChartEntry>(
      (prev, curr) => {
        const next: BarChartEntry = { ...prev };
        numericKeys.forEach(key => {
          const prevVal =
            typeof next[key] === 'number' ? (next[key] as number) : 0;
          const currVal =
            typeof curr[key] === 'number' ? (curr[key] as number) : 0;
          next[key] = prevVal + currVal;
        });
        return next;
      },
      { label: 'Other' } as BarChartEntry,
    );

  const withOther =
    [...entries].length > otherThreshold - 1
      ? [...highestEntries, otherEntry]
      : highestEntries;

  const finalEntries = withOther.filter(entry => getEntryTotal(entry) > 0);

  const colors = buildGradientColors(
    numericKeys.length,
    theme.palette.primary.main,
    theme.palette.emerald.main,
  );

  return {
    finalEntries,
    totalValue,
    colors,
    valueKeys: numericKeys,
  };
};
